export default __webpack_public_path__ + "static/media/MachineSpeedHour.286fb2f1.jpg";